const MtrPaperclipOutline = {
  name: 'mtr-paperclip',
  theme: 'outline',
  icon: {
    tag: 'svg',
    attrs: {
      fill: 'none',
      height: '24',
      stroke: 'currentColor',
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round',
      'stroke-width': '2',
      viewBox: '0 0 24 24',
      width: '24',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    children: [
      {
        tag: 'path',
        attrs: {
          d:
            'M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48',
        },
      },
    ],
  },
};
export default MtrPaperclipOutline;
